export const movies = [
  {
    id: "m1",
    title: "长夜将明",
    type: "电视剧",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20suspense%20tv%20series%20poster%20art%2C%20a%20lone%20figure%20standing%20under%20a%20street%20lamp%20at%20night%20in%20the%20rain%2C%20deep%20navy%20blue%20tones%20with%20warm%20amber%20light%2C%20dramatic%20moody%20lighting%2C%20minimalist%20bold%20composition%2C%20atmospheric%20mystery%20background%2C%20high%20detail&width=600&height=900&seq=movie-cover-01&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20banner%20of%20a%20rainy%20city%20skyline%20at%20night%20with%20glowing%20amber%20windows%20against%20deep%20navy%20blue%20sky%2C%20dramatic%20moody%20atmosphere%2C%20mysterious%20urban%20noir%20lighting%2C%20high%20detail%20cinematic%20photography%2C%20wide%20empty%20space%20on%20left%20for%20text&width=1920&height=900&seq=movie-banner-01&orientation=landscape",
    year: 2024,
    genres: ["悬疑", "犯罪"],
    region: "国产",
    director: "陈默",
    actors: [
      { id: "a1", name: "林晚舟" },
      { id: "a4", name: "陆时衍" },
    ],
    duration: "45分钟/集",
    rating: 9.2,
    views: 3280000,
    summary:
      "一座被大雨笼罩的南方小城，连环失踪案让平静的生活暗流涌动。刑警队长江砚与法医顾清在层层迷雾中追寻真相，却发现自己也早已身陷其中。当所有线索指向一个不可能存在的影子，长夜之下，真相与谎言只隔着一线微光。",
    tags: ["烧脑", "高口碑", "演技派"],
    isHot: true,
    isNew: true,
  },
  {
    id: "m2",
    title: "春日暖阳",
    type: "电视剧",
    cover:
      "https://readdy.ai/api/search-image?query=romantic%20drama%20poster%20art%2C%20two%20young%20people%20standing%20in%20a%20sunlit%20field%20of%20flowers%2C%20soft%20golden%20warm%20orange%20light%20with%20gentle%20blue%20sky%2C%20dreamy%20soft%20focus%2C%20minimalist%20elegant%20composition%2C%20heartwarming%20atmosphere%2C%20high%20detail&width=600&height=900&seq=movie-cover-02&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=warm%20sunlit%20countryside%20landscape%20at%20golden%20hour%20with%20flower%20fields%20and%20soft%20orange%20sunlight%20against%20a%20pale%20blue%20sky%2C%20romantic%20dreamy%20atmosphere%2C%20cinematic%20photography%2C%20wide%20empty%20space%20for%20text%20overlay&width=1920&height=900&seq=movie-banner-02&orientation=landscape",
    year: 2023,
    genres: ["爱情", "都市"],
    region: "国产",
    director: "许静",
    actors: [
      { id: "a2", name: "苏慕白" },
      { id: "a5", name: "江月明" },
    ],
    duration: "40分钟/集",
    rating: 8.4,
    views: 2140000,
    summary:
      "花店老板苏晚与失意的建筑师程野在春日的小镇相遇。两个被生活磨去棱角的人，因为一间即将拆迁的老宅走到一起。他们决定用整个春天，为这座老宅、也为自己，重新建一个家。",
    tags: ["治愈", "甜宠", "慢节奏"],
    isHot: true,
    isNew: false,
  },
  {
    id: "m3",
    title: "山海秘境",
    type: "电影",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20fantasy%20adventure%20movie%20poster%2C%20a%20lone%20traveler%20standing%20at%20the%20edge%20of%20a%20misty%20grand%20canyon%2C%20deep%20teal%20blue%20mountains%20with%20glowing%20orange%20sunrise%2C%20mythical%20legendary%20atmosphere%2C%20bold%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=movie-cover-03&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20wide%20fantasy%20landscape%20of%20floating%20mountains%20above%20the%20clouds%20at%20sunrise%2C%20deep%20blue%20mist%20with%20glowing%20orange%20light%20breaking%20through%2C%20mythical%20grand%20cinematic%20scale%2C%20high%20detail%20with%20empty%20sky%20space%20for%20title&width=1920&height=900&seq=movie-banner-03&orientation=landscape",
    year: 2024,
    genres: ["奇幻", "冒险"],
    region: "国产",
    director: "韩川",
    actors: [
      { id: "a3", name: "顾清欢" },
      { id: "a4", name: "陆时衍" },
    ],
    duration: "128分钟",
    rating: 8.1,
    views: 1760000,
    summary:
      "古籍修复师意外得到一枚上古玉简，从此踏入地图上不存在的山海秘境。为了找回失踪的师父，她必须穿越九重幻境，解开一个沉睡千年的秘密。",
    tags: ["视效大片", "东方奇幻", "合家欢"],
    isHot: true,
    isNew: true,
  },
  {
    id: "m4",
    title: "都市浮生",
    type: "电视剧",
    cover:
      "https://readdy.ai/api/search-image?query=urban%20drama%20poster%20art%2C%20a%20crowded%20city%20street%20at%20dusk%20seen%20from%20above%20with%20tiny%20figures%2C%20cool%20blue%20grey%20tones%20with%20warm%20orange%20streetlights%2C%20introspective%20moody%20atmosphere%2C%20minimalist%20contemporary%20composition%2C%20high%20detail&width=600&height=900&seq=movie-cover-04&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=aerial%20view%20of%20a%20modern%20city%20at%20dusk%2C%20cool%20blue%20grey%20buildings%20with%20warm%20orange%20lights%20turning%20on%20one%20by%20one%2C%20urban%20melancholic%20atmosphere%2C%20cinematic%20photography%2C%20wide%20empty%20space%20for%20text&width=1920&height=900&seq=movie-banner-04&orientation=landscape",
    year: 2022,
    genres: ["都市", "剧情"],
    region: "国产",
    director: "周黎",
    actors: [
      { id: "a6", name: "沈知遥" },
      { id: "a1", name: "林晚舟" },
    ],
    duration: "42分钟/集",
    rating: 8.7,
    views: 1490000,
    summary:
      "五个在写字楼里进进出出的普通人，白天是光鲜的职场精英，深夜才敢露出真实的疲惫。一部关于理想、妥协与坚持的都市群像剧。",
    tags: ["现实主义", "群像", "职场"],
    isHot: false,
    isNew: false,
  },
  {
    id: "m5",
    title: "暗涌",
    type: "电视剧",
    cover:
      "https://readdy.ai/api/search-image?query=spy%20thriller%20poster%20art%2C%20a%20man%20in%20a%20raincoat%20silhouette%20in%20a%20dim%20corridor%2C%20deep%20navy%20blue%20shadows%20with%20a%20single%20warm%20orange%20light%20source%2C%20tense%20suspenseful%20atmosphere%2C%20film%20noir%20minimalist%20composition%2C%20high%20detail&width=600&height=900&seq=movie-cover-05&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=dim%20empty%20corridor%20with%20a%20single%20warm%20orange%20lamp%20and%20long%20deep%20blue%20shadows%2C%20tense%20espionage%20thriller%20atmosphere%2C%20film%20noir%20cinematic%20lighting%2C%20wide%20empty%20space%20for%20text%20overlay&width=1920&height=900&seq=movie-banner-05&orientation=landscape",
    year: 2024,
    genres: ["谍战", "悬疑"],
    region: "国产",
    director: "陈默",
    actors: [
      { id: "a4", name: "陆时衍" },
      { id: "a2", name: "苏慕白" },
    ],
    duration: "46分钟/集",
    rating: 8.8,
    views: 1920000,
    summary:
      "一份遗失的密码本，让潜伏多年的情报员暴露在危险之中。在敌我难辨的棋局里，他必须用最冷静的方式，走完这最后一步。",
    tags: ["强情节", "双男主", "反转"],
    isHot: true,
    isNew: true,
  },
  {
    id: "m6",
    title: "花开半夏",
    type: "电视剧",
    cover:
      "https://readdy.ai/api/search-image?query=youth%20romance%20poster%20art%2C%20two%20students%20on%20a%20bicycle%20under%20summer%20trees%2C%20fresh%20green%20and%20soft%20blue%20tones%20with%20warm%20orange%20sunset%20light%2C%20nostalgic%20bittersweet%20atmosphere%2C%20minimalist%20delicate%20composition%2C%20high%20detail&width=600&height=900&seq=movie-cover-06&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=campus%20lane%20lined%20with%20trees%20in%20summer%20with%20warm%20orange%20sunset%20light%20filtering%20through%20green%20leaves%2C%20nostalgic%20youthful%20atmosphere%2C%20dreamy%20cinematic%20photography%2C%20wide%20empty%20space%20for%20text&width=1920&height=900&seq=movie-banner-06&orientation=landscape",
    year: 2021,
    genres: ["青春", "爱情"],
    region: "国产",
    director: "许静",
    actors: [
      { id: "a5", name: "江月明" },
      { id: "a3", name: "顾清欢" },
    ],
    duration: "38分钟/集",
    rating: 8.0,
    views: 1280000,
    summary:
      "高二那个夏天，转学生夏栀住进了半山腰的老宅，也闯进了少年陆岩安静的世界。一段关于暗恋、离别与重逢的青春记忆。",
    tags: ["校园", "初恋", "回忆杀"],
    isHot: false,
    isNew: false,
  },
  {
    id: "m7",
    title: "星际迷途",
    type: "电影",
    cover:
      "https://readdy.ai/api/search-image?query=science%20fiction%20space%20movie%20poster%2C%20a%20lone%20astronaut%20floating%20in%20front%20of%20a%20giant%20ringed%20planet%2C%20deep%20blue%20void%20with%20glowing%20orange%20star%2C%20epic%20vast%20cosmic%20atmosphere%2C%20minimalist%20bold%20composition%2C%20high%20detail&width=600&height=900&seq=movie-cover-07&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20wide%20space%20scene%20with%20a%20distant%20glowing%20orange%20nebula%20against%20a%20deep%20blue%20starfield%2C%20vast%20cosmic%20loneliness%2C%20cinematic%20sci-fi%20photography%2C%20high%20detail%20with%20empty%20space%20for%20title&width=1920&height=900&seq=movie-banner-07&orientation=landscape",
    year: 2023,
    genres: ["科幻", "冒险"],
    region: "欧美",
    director: "Leo Marchetti",
    actors: [
      { id: "a3", name: "顾清欢" },
      { id: "a6", name: "沈知遥" },
    ],
    duration: "142分钟",
    rating: 8.6,
    views: 2050000,
    summary:
      "深空探测器「回声号」在返航途中失联。女指挥官独自醒来，发现飞船偏离了航线，而导航记录里多出一段从未存在的信号。",
    tags: ["硬科幻", "太空", "孤独"],
    isHot: true,
    isNew: false,
  },
  {
    id: "m8",
    title: "老巷人家",
    type: "电视剧",
    cover:
      "https://readdy.ai/api/search-image?query=family%20drama%20poster%20art%2C%20a%20warm%20lit%20old%20alley%20at%20evening%20with%20steaming%20food%20stall%2C%20warm%20orange%20lantern%20light%20with%20deep%20blue%20dusk%20sky%2C%20nostalgic%20heartwarming%20atmosphere%2C%20cinematic%20cozy%20composition%2C%20high%20detail&width=600&height=900&seq=movie-cover-08&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=a%20narrow%20old%20residential%20alley%20at%20dusk%20with%20warm%20orange%20lanterns%20and%20steam%20rising%20from%20food%20stalls%2C%20cozy%20nostalgic%20atmosphere%20under%20a%20deep%20blue%20sky%2C%20cinematic%20photography%2C%20wide%20space%20for%20text&width=1920&height=900&seq=movie-banner-08&orientation=landscape",
    year: 2023,
    genres: ["家庭", "剧情"],
    region: "国产",
    director: "周黎",
    actors: [
      { id: "a6", name: "沈知遥" },
      { id: "a1", name: "林晚舟" },
    ],
    duration: "44分钟/集",
    rating: 9.0,
    views: 1680000,
    summary:
      "城南的百年老巷即将拆除，三户人家在最后的半年里，把几十年的恩怨、秘密和温情，一锅一锅地炖进了饭菜里。",
    tags: ["烟火气", "群像", "催泪"],
    isHot: false,
    isNew: true,
  },
  {
    id: "m9",
    title: "追光者",
    type: "电影",
    cover:
      "https://readdy.ai/api/search-image?query=inspirational%20drama%20movie%20poster%2C%20a%20runner%20silhouette%20sprinting%20toward%20a%20bright%20orange%20sunrise%20at%20the%20end%20of%20a%20long%20dark%20road%2C%20deep%20blue%20pre-dawn%20tones%2C%20hopeful%20uplifting%20atmosphere%2C%20bold%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=movie-cover-09&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=a%20long%20empty%20road%20leading%20toward%20a%20glowing%20orange%20sunrise%20on%20the%20horizon%20under%20a%20deep%20blue%20pre-dawn%20sky%2C%20hopeful%20rising%20atmosphere%2C%20cinematic%20wide%20photography%2C%20space%20for%20text%20overlay&width=1920&height=900&seq=movie-banner-09&orientation=landscape",
    year: 2024,
    genres: ["励志", "剧情"],
    region: "国产",
    director: "韩川",
    actors: [
      { id: "a2", name: "苏慕白" },
      { id: "a5", name: "江月明" },
    ],
    duration: "118分钟",
    rating: 8.3,
    views: 1320000,
    summary:
      "一场意外夺走了他的左腿，也几乎夺走了他奔跑的资格。当所有人都劝他停下来时，他决定重新学习走路，然后去追那个再也追不上的光。",
    tags: ["励志", "热血", "真实改编"],
    isHot: false,
    isNew: true,
  },
  {
    id: "m10",
    title: "镜中迷城",
    type: "电影",
    cover:
      "https://readdy.ai/api/search-image?query=psychological%20thriller%20movie%20poster%2C%20a%20distorted%20city%20reflection%20in%20a%20cracked%20mirror%20with%20a%20shattered%20silhouette%2C%20cold%20blue%20grey%20tones%20with%20eerie%20orange%20glow%2C%20unsettling%20surreal%20atmosphere%2C%20minimalist%20striking%20composition%2C%20high%20detail&width=600&height=900&seq=movie-cover-10&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=a%20surreal%20distorted%20cityscape%20seen%20through%20a%20cracked%20glass%20surface%2C%20cold%20blue%20grey%20with%20an%20eerie%20warm%20orange%20glow%2C%20unsettling%20thriller%20atmosphere%2C%20cinematic%20photography%2C%20wide%20space%20for%20text&width=1920&height=900&seq=movie-banner-10&orientation=landscape",
    year: 2022,
    genres: ["悬疑", "惊悚"],
    region: "日韩",
    director: "佐藤遥",
    actors: [
      { id: "a4", name: "陆时衍" },
      { id: "a3", name: "顾清欢" },
    ],
    duration: "106分钟",
    rating: 7.9,
    views: 980000,
    summary:
      "心理医生在一场车祸后，发现自己每天都会在镜子里看到一个不一样的世界。当两个世界的界限逐渐模糊，她开始分不清哪个才是真正的自己。",
    tags: ["心理", "烧脑", "画风独特"],
    isHot: false,
    isNew: false,
  },
  {
    id: "m11",
    title: "江湖夜雨",
    type: "电视剧",
    cover:
      "https://readdy.ai/api/search-image?query=chinese%20wuxia%20period%20drama%20poster%2C%20a%20swordsman%20standing%20in%20the%20rain%20on%20an%20ancient%20rooftop%2C%20deep%20ink%20blue%20night%20with%20warm%20orange%20lantern%20light%2C%20martial%20arts%20melancholic%20atmosphere%2C%20ink%20painting%20minimalist%20composition%2C%20high%20detail&width=600&height=900&seq=movie-cover-11&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20rooftops%20in%20the%20rain%20at%20night%20with%20distant%20warm%20orange%20lanterns%2C%20deep%20ink%20blue%20misty%20atmosphere%2C%20wuxia%20martial%20arts%20cinematic%20mood%2C%20wide%20space%20for%20text%20overlay&width=1920&height=900&seq=movie-banner-11&orientation=landscape",
    year: 2021,
    genres: ["武侠", "古装"],
    region: "国产",
    director: "韩川",
    actors: [
      { id: "a1", name: "林晚舟" },
      { id: "a4", name: "陆时衍" },
    ],
    duration: "43分钟/集",
    rating: 8.5,
    views: 1590000,
    summary:
      "十年前的一场江湖大火，烧尽了归云楼，也烧出了两个人的宿命。十年后夜雨重逢，他们终于要问一句：当年那把火，究竟是谁点的。",
    tags: ["武侠", "东方美学", "意难平"],
    isHot: false,
    isNew: false,
  },
  {
    id: "m12",
    title: "蓝色回响",
    type: "电影",
    cover:
      "https://readdy.ai/api/search-image?query=artistic%20drama%20movie%20poster%2C%20a%20lone%20woman%20standing%20at%20the%20edge%20of%20a%20calm%20blue%20sea%20at%20twilight%2C%20muted%20deep%20blue%20water%20with%20a%20hint%20of%20warm%20orange%20horizon%2C%20quiet%20contemplative%20atmosphere%2C%20minimalist%20poetic%20composition%2C%20high%20detail&width=600&height=900&seq=movie-cover-12&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=a%20vast%20calm%20blue%20sea%20at%20twilight%20with%20a%20faint%20warm%20orange%20horizon%20line%2C%20quiet%20poetic%20melancholic%20atmosphere%2C%20minimalist%20cinematic%20photography%2C%20wide%20empty%20space%20for%20text&width=1920&height=900&seq=movie-banner-12&orientation=landscape",
    year: 2020,
    genres: ["剧情", "文艺"],
    region: "欧美",
    director: "Leo Marchetti",
    actors: [
      { id: "a6", name: "沈知遥" },
      { id: "a2", name: "苏慕白" },
    ],
    duration: "112分钟",
    rating: 8.2,
    views: 760000,
    summary:
      "一位年迈的海洋声音采集师，用四十年的录音带记录着同一片海湾的潮起潮落。当她决定卖掉老屋时，她要把这片海的声音，留给一个从未见过海的人。",
    tags: ["文艺", "慢电影", "治愈"],
    isHot: false,
    isNew: false,
  },
  {
    id: "m13",
    title: "东京物语集",
    type: "电视剧",
    cover:
      "https://readdy.ai/api/search-image?query=quiet%20family%20drama%20poster%2C%20a%20small%20tokyo%20apartment%20window%20lit%20warmly%20at%20night%2C%20muted%20blue%20grey%20city%20tones%20with%20warm%20orange%20interior%20light%2C%20gentle%20melancholic%20atmosphere%2C%20minimalist%20delicate%20composition%2C%20high%20detail&width=600&height=900&seq=movie-cover-13&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=a%20quiet%20residential%20street%20in%20tokyo%20at%20dusk%20with%20warm%20orange%20window%20lights%2C%20muted%20blue%20grey%20melancholic%20atmosphere%2C%20restrained%20cinematic%20photography%2C%20wide%20space%20for%20text&width=1920&height=900&seq=movie-banner-13&orientation=landscape",
    year: 2022,
    genres: ["剧情", "家庭"],
    region: "日韩",
    director: "佐藤遥",
    actors: [
      { id: "a5", name: "江月明" },
      { id: "a6", name: "沈知遥" },
    ],
    duration: "48分钟/集",
    rating: 8.9,
    views: 1120000,
    summary:
      "东京一间老公寓里，房东与四位性格各异的租客，在四季流转中各自面对离别与重逢。四个独立的故事，拼出一个关于「家」的答案。",
    tags: ["单元剧", "治愈", "高口碑"],
    isHot: false,
    isNew: false,
  },
  {
    id: "m14",
    title: "西部往事",
    type: "电影",
    cover:
      "https://readdy.ai/api/search-image?query=western%20drama%20movie%20poster%2C%20a%20lonely%20cowboy%20silhouette%20on%20horseback%20against%20a%20huge%20sunset%2C%20dusty%20orange%20desert%20sky%20with%20deep%20blue%20long%20shadows%2C%20epic%20lonely%20atmosphere%2C%20bold%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=movie-cover-14&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20wide%20western%20desert%20landscape%20at%20sunset%20with%20distant%20mesa%20rock%20formations%2C%20dusty%20orange%20sky%20with%20deep%20blue%20shadows%2C%20lonely%20epic%20atmosphere%2C%20cinematic%20photography%2C%20space%20for%20title&width=1920&height=900&seq=movie-banner-14&orientation=landscape",
    year: 2021,
    genres: ["剧情", "西部"],
    region: "欧美",
    director: "Leo Marchetti",
    actors: [
      { id: "a4", name: "陆时衍" },
      { id: "a1", name: "林晚舟" },
    ],
    duration: "134分钟",
    rating: 8.4,
    views: 890000,
    summary:
      "一个不再开一枪的枪手，受雇护送一列满载秘密的火车穿越荒原。在漫长的旅途中，他要面对的不仅是劫匪，还有自己无法摆脱的过去。",
    tags: ["西部", "硬汉", "史诗"],
    isHot: false,
    isNew: false,
  },
];